import * as React from "react";
import Masonry from "react-masonry-css";
import "./MasonryGallery.css";

export interface IMasonryGalleryProps {
  children: any;
}

const breakpointColumnsObj = {
  default: 4,
  1200: 3,
  800: 2,
  600: 1
};

const MasonryGallery = ({ children }: IMasonryGalleryProps) => {
  return (
    <Masonry breakpointCols={breakpointColumnsObj} className="masonry-gallery" columnClassName="masonry-grid_column">
      {children}
    </Masonry>
  );
};

export default MasonryGallery;



// WEBPACK FOOTER //
// ./src/share/components/Masonry/MasonryGallery.tsx